export const hexToRgb = (hex: string) => {
  hex = hex.replace(/^#/, "");
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
};

export const rgbToRgba = ([r, g, b]: number[], alpha: number) => {
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const rgbToLuminance = ([r, g, b]: number[]) => {
  const srgbToLinear = (c: number) => {
    c /= 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  };

  r = srgbToLinear(r);
  g = srgbToLinear(g);
  b = srgbToLinear(b);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const hexToRgba = (hex: string, alpha: number) => {
  const rgb = hexToRgb(hex);
  return rgbToRgba(rgb, alpha);
};

export const isDarkMode = (hex: string) => {
  const rgb = hexToRgb(hex);
  const luminance = rgbToLuminance(rgb);
  return luminance < 0.5;
};
